<template>
  <ElDialog
    class="modal"
    :visible.sync="showModal"
    :width="modalWidth"
  >
    <h2 class="modal__title">
      {{ title }}
    </h2>
    <div class="modal__body">
      <p class="modal__text">
        {{ text }}
      </p>
    </div>
      <div class="modal__submit-buttons">
          <BaseButton
              class=""
              text="Закрыть"
              size="large"
              native-type="submit"
              @click.native="close()"
          />
      </div>
  </ElDialog>
</template>

<script>
import { matchesEmailRegex, numbersLengthFromString } from '@/utils/string-helpers';
import { validationHandler } from '@/utils/validation';
import { PHONE_LENGTH } from '@/consts';
import modal from '@/mixins/modal';
import BaseButton from '@/components/ui/BaseButton';

export default {
  name: 'ModalError',
  components: {
    BaseButton
  },
  mixins: [modal],
  props: {
       
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
      close() {
          this.$emit('close');
      },
  },
}
</script>

<style lang="scss" scoped>
.feedback-form__submit-buttons .button {
  width: calc(50% - 10px);
}
.modal {
  &__text {
    &:not(:last-child) {
      margin-bottom: rem(32);
    }
  }

  &__title { 
    margin-bottom: 20px;
    font-size: 24px; 
  }

  &__text { 
    margin-bottom: 30px;
    color: #555; 
  }
}


.feedback-form-section {
}

.feedback-form__title {
  margin-bottom: 20px;
  font-size: 20px;
}

.feedback-form__text {
  font-size: 16px;
  margin-bottom: 30px;
  color: #555;
}

.form__item {
  display: flex;
  margin-bottom: 20px;
}

.form__item--col {
  gap: 20px;
}

.form__col {
  flex: 1;
}

.form__col--half {
  flex-basis: calc(50% - 10px);
}

.form__col--agreement {
  :deep(.el-form-item__content) {
    line-height: normal; 
  }
}

.agreement-text {
  font-size: rem(12);
  color: #555;
  line-height: 1.4;
  display: inline; 
}

.agreement-link {
  color: $bondi-blue; 
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
}
</style>
